module.exports = __webpack_public_path__ + "img/rect.b915a67c.svg";